export default __webpack_public_path__ + "static/media/mess.085d92d6.svg";